import {englishType} from 'types'

export const lesson24: englishType[] = [
  {
    id: 1,
    word: "application",
    meaning: ["지원", "신청"]
  },
  {
    id: 2,
    word: "bracelet",
    meaning: ["팔찌"]
  },
  {
    id: 3,
    word: "conflict",
    meaning: ["갈등", "충돌"]
  },
  {
    id: 4,
    word: "charity",
    meaning: ["자선 단체", "구호 단체"]
  },
  {
    id: 5,
    word: "purchase",
    meaning: ["구매하다", "구입하다"]
  },
  {
    id: 6,
    word: "be eager to",
    meaning: ["간절히 바라다", "소망하다", "하고 싶어하다"]
  },
  {
    id: 7,
    word: "fundraising",
    meaning: ["모금", "자금조달"]
  },
  {
    id: 8,
    word: "every other year",
    meaning: ["격년"]
  },
  {
    id: 9,
    word: "clown",
    meaning: ["광대"]
  },
  {
    id: 10,
    word: "lift",
    meaning: ["상황을 나아지게 하다", "향상시키다"]
  },
  {
    id: 11,
    word: "poverty",
    meaning: ["가난", "빈곤"]
  },
  {
    id: 12,
    word: "sorrow",
    meaning: ["슬픔"]
  },
  {
    id: 13,
    word: "decrease",
    meaning: ["감소하다", "줄어들다", "줄이다", "줄다"]
  },
  {
    id: 14,
    word: "nonprofit",
    meaning: ["비영리적인"]
  },
  {
    id: 15,
    word: "distribute",
    meaning: ["나누다", "분배하다"]
  },
  {
    id: 16,
    word: "shelter",
    meaning: ["보호소", "쉼터"]
  },
  {
    id: 17,
    word: "food drive",
    meaning: ["음식 기부 단체", "음식 기부 행사"]
  },
  {
    id: 18,
    word: "individual",
    meaning: ["개인의", "개별의"]
  },
  {
    id: 19,
    word: "recommend",
    meaning: ["추천하다", "권고하다"]
  },
  {
    id: 20,
    word: "entry fee",
    meaning: ["참가료", "참가비", "입장료", "입장비", "가입료", "가입비"]
  },
  {
    id: 21,
    word: "costume",
    meaning: ["의상"]
  },
  {
    id: 22,
    word: "split",
    meaning: ["정신", "영혼"]
  },
  {
    id: 23,
    word: "disadvantaged",
    meaning: ["혜택을 받지 못하는", "혜택을 받지 못한", "빈곤한"]
  },
  {
    id: 24,
    word: "donate",
    meaning: ["기부하다", "기증하다"]
  },
  {
    id: 25,
    word: "all day",
    meaning: ["하루 종일", "온종일"]
  },
  {
    id: 26,
    word: "raise",
    meaning: ["모으다"]
  },
  {
    id: 27,
    word: "nigeria",
    meaning: ["나이지리아"]
  },
  {
    id: 28,
    word: "organization",
    meaning: ["단체", "조직"]
  },
  {
    id: 29,
    word: "joy",
    meaning: ["기쁨", "즐거움", "환희"]
  },
  {
    id: 30,
    word: "guess",
    meaning: ["추측하다"]
  },
  {
    id: 31,
    word: "senior center",
    meaning: ["노인센터", "노인복지관"]
  },
  {
    id: 32,
    word: "the hungry",
    meaning: ["배고픈 사람"]
  },
  {
    id: 33,
    word: "food bank",
    meaning: ["무료 급식소"]
  },
  {
    id: 34,
    word: "to mark",
    meaning: ["기념하기 위해"]
  },
  {
    id: 35,
    word: "detail",
    meaning: ["세부 사항", "상세 사항", "상세 항목"]
  },
  {
    id: 36,
    word: "gather",
    meaning: ["모으다", "수집하다"]
  },
  {
    id: 37,
    word: "realize",
    meaning: ["깨닫다", "알아차리다", "인식하다", "자각하다", "실현하다"]
  },
  {
    id: 38,
    word: "kindness",
    meaning: ["친절", "다정함"]
  },
  {
    id: 39,
    word: "strongly",
    meaning: ["강하게", "독하게"]
  },
  {
    id: 40,
    word: "annual",
    meaning: ["한 해의", "매년의", "연례의", "연중의", "연간의"]
  },
  {
    id: 41,
    word: "fundraiser",
    meaning: ["모금 행사", "기금 행사"]
  },
  {
    id: 42,
    word: "part in",
    meaning: ["참가하다", "참여하다"]
  },
  {
    id: 43,
    word: "you want to kill two birds with one stone",
    meaning: ["일석이조"]
  },
  {
    id: 44,
    word: "dry cleaner",
    meaning: ["세탁소"]
  },
  {
    id: 45,
    word: "hanger",
    meaning: ["옷걸이"]
  },
  {
    id: 46,
    word: "school uniform",
    meaning: ["교복"]
  },
  {
    id: 47,
    word: "encouraged",
    meaning: ["격려하다", "독려하다"]
  },
  {
    id: 48,
    word: "the homeless",
    meaning: ["노숙자들"]
  },
  {
    id: 49,
    word: "one piece",
    meaning: ["옷 한 벌"]
  },
  {
    id: 50,
    word: "inexpensive",
    meaning: ["비싸지 않은", "비싸지 않는"]
  },
  {
    id: 51,
    word: "looking forward to",
    meaning: ["~을 기대하다", "~를 기대하다", "~를 학수고대하다", "~을 학수고대하다"]
  },
  {
    id: 52,
    word: "make bonds",
    meaning: ["유대를 만들다", "유대를 형성하다"]
  },
  {
    id: 53,
    word: "rather",
    meaning: ["꽤나", "꽤", "약간", "상당히", "조금"]
  },
  {
    id: 54,
    word: "survive",
    meaning: ["살아남다", "생존하다", "견뎌 내다"]
  },
  {
    id: 55,
    word: "make a living",
    meaning: ["생계를 꾸리다", "생계를 가꾸다"]
  },
  {
    id: 56,
    word: "bond",
    meaning: ["접착", "유대"]
  },
  {
    id: 57,
    word: "not A but B",
    meaning: ["A가 아니라 B", "A가 아닌 B"]
  },
  {
    id: 58,
    word: "option",
    meaning: ["선택"]
  },
  {
    id: 59,
    word: "requirement",
    meaning: ["필요", "필요 조건", "요건"]
  },
  {
    id: 60,
    word: "touching",
    meaning: ["감동적인"]
  },
  {
    id: 61,
    word: "cooperative",
    meaning: ["협력하는", "협조하는"]
  },
  {
    id: 62,
    word: "cooperation",
    meaning: ["협력", "협조"]
  },
  {
    id: 63,
    word: "inspiring",
    meaning: ["영감을 주는", "고무하는", "격려하는", "자극하는"]
  },
  {
    id: 64,
    word: "precious",
    meaning: ["귀중한", "값비싼", "소중한"]
  },
  {
    id: 65,
    word: "behavior",
    meaning: ["행동", "거동", "품행", "태도"]
  },
  {
    id: 66,
    word: "necessary",
    meaning: ["필요한", "불가피한", "필연적인"]
  },
  {
    id: 67,
    word: "important to",
    meaning: ["~에게 중요한", "~는 중요하다", "~가 중요하다"]
  },
  {
    id: 68,
    word: "thinking of",
    meaning: ["~을 고려하다", "~를 고려하다"]
  },
  {
    id: 69,
    word: "pocket money",
    meaning: ["용돈", "푼돈"]
  },
  {
    id: 70,
    word: "instrument",
    meaning: ["악기"]
  },
  {
    id: 71,
    word: "vacuum",
    meaning: ["진공청소기"]
  },
  {
    id: 72,
    word: "purpose",
    meaning: ["목적"]
  },
]
